import { defineMessages } from 'react-intl';

export default defineMessages({
  preview: 'Survey Preview',
  noWebsite: '(No website)',

  style: 'Behaviour',
  trigger: 'Trigger',
  triggerNone: 'Immediate',
  noTriggerDescription: 'This will show the survey immediately.',
  triggerTimer: 'Timer',
  triggerButton: 'Button',
  triggerExistingButton: 'Existing button',
  triggerInvisibleLayer: 'Overlay',
  triggerStyle: 'Button style',
  floating: 'Floating',
  fixed: 'Fixed',
  triggerPosition: 'Button position',
  centerRight: 'Center right',
  bottomRight: 'Bottom right',
  bottomLeft: 'Bottom left',
  buttonIcon: 'Button icon',
  buttonLabel: 'Button label',
  container: 'Survey display style',
  containerPopupWindow: 'Popup',
  containerPopupModal: 'Modal',
  containerSpeechBubble: 'Speech bubble',
  containerEmbed: 'Embedded',
  containerNewWindow: 'New tab',
  popupWidth: 'Width',
  popupHeight: 'Height',
  delay: 'How long the visitor needs to be active on the website across all visits before showing the survey',
  sessionDelay: 'How long the visitor needs to be active when coming back',
  declineFrequency: 'How long to wait before showing again if not responding',
  frequency: 'How long to wait before a visitor can retake the survey',
  sharedSurveys: 'Share timers with these surveys',
  buttonSelector: 'CSS selector for the button that should trigger the survey',
  buttonSelectorPlaceholder: '#myButton',
  containerSelector: 'CSS selector for the container where we should place the survey',
  containerSelectorPlaceholder: '#myContainer',
  saveStyleSuccess: 'Distribution style saved!',
  saveStyleError: 'Failed to save style settings. Please try again later.',
  quizMode: 'Quiz mode',
  quizModeLabel: 'Use quiz mode',
  quizModeTooltip: 'Will show one question per page and move forward automatically when appropriate',

  design: 'Design',
  logoSource: 'Logo',
  logoSourceCustomer: 'Customer',
  logoSourceCustomerMissing: 'Customer has no logo, upload one to use it here.',
  logoSourceUrl: 'Custom URL',
  logoSourceNone: 'No logo',
  logoUrl: 'Logo URL',
  logoHeight: 'Logo height',
  customThemeDisclaimer: 'Our default and dark themes are WCAG AA compatible. If you switch to a custom theme we can no longer guarantee that.',
  useToggleButtons: 'Option appearence',
  useToggleButtonsTooltip: 'Use toggle buttons for options instead of radio buttons or checkboxes',
  useToggleButtonsLabel: 'Use toggle buttons',

  pageBackgroundColor: 'Page background (desktop only)',
  surveyBackgroundColor: 'Survey background',
  borderColor: 'Survey border',
  headerColor: 'Headings',
  textColor: 'Text',
  linkColor: 'Links',
  questionColor: 'Question titles',
  descriptionColor: 'Question descriptions',
  disclaimerColor: 'Disclaimers',
  inputBorderColor: 'Input border',
  inputBackgroundColor: 'Input background',
  inputTextColor: 'Input text',
  inputSelectedBorderColor: 'Selected input border',
  inputSelectedBackgroundColor: 'Selected input background',
  inputSelectedTextColor: 'Selected input text',
  inputFocusColor: 'Input focus',
  inputErrorColor: 'Invalid input',
  buttonColor: 'Buttons',
  buttonTextColor: 'Button text',
  acceptButtonColor: 'Accept button',
  acceptButtonTextColor: 'Accept button text',
  declineButtonColor: 'Decline button',
  declineButtonTextColor: 'Decline button text',
  progressBarBackgroundColor: 'Progress bar background',
  progressBarColor: 'Progress bar',
  cornerRadius: 'Button corner radius',
  customCSS: 'Custom CSS',
  customThemeDisabled: 'Upgrade your license to use a custom theme.',

  saveDesignSuccess: 'Distribution design saved!',
  saveDesignError: 'Failed to save design settings. Please try again later.',

  audience: 'Audience',
  portion: 'Portion of visitors to receive the survey',
  deviceTypes: 'Device types',
  excludedIPs: 'IP addresses to exclude from getting the survey',
  excludedIPsPlaceholder: 'Add one IP per line, supports partial match.',
  saveAudienceSuccess: 'Audience settings saved!',
  saveAudienceError: 'Failed to save audience settings. Please try again later.',

  publish: 'Publish',
  startDate: 'Start',
  endDate: 'End',
  never: 'Never',
  includedUrls: 'Included urls',
  includedUrlsDescription: 'Specify full urls or patterns to show the survey on. It has to be within the website url.',
  excludedUrls: 'Excluded urls',
  excludedUrlsDescription: 'Specify full urls or patterns to not show the survey on.',
  urlsPlaceholder: 'Examples:\n/path/\nquery=param',
  publishSuccess: 'Survey will be live {publishDate}',
  publishSuccessNoDate: 'Survey distribution saved!',
  publishError: 'Failed to publish survey. Please try again later.',
});
